import { camelCase } from 'change-case';
import Mime from 'mime/lite';
import { ExportValue } from '../ExportDimension';
import { ExportFormat, ExportOutput } from '../ExportFormat';

export class JsonExportFormat implements ExportFormat {

    public readonly id = 'json';
    public readonly label = 'JSON';
    public readonly desc = 'If you don\'t know what this is for, ask a developer.  They might give you a straight answer.';

    public apply(data: ExportValue[][]): ExportOutput[] {

        const [head, ...body] = data.map(row => row.map(cell => cell.value));
        const mapped = body.map(row => Object.fromEntries(row.map((x, i) => [camelCase(head[i]), x])));
        const encoded = JSON.stringify(mapped, null, 4);

        return [
            ExportOutput(Mime.getType('json'), encoded),
            ExportOutput(Mime.getType('text'), encoded)
        ];
    }

}
